// extracted by mini-css-extract-plugin
export default {"overlay":"DeleteLossReasonButton_overlay__1UODI","deleteIcon":"DeleteLossReasonButton_deleteIcon__WrQNw"};